module.exports = __webpack_public_path__ + "static/media/back-arrow.6d0be7be.svg";